export const getLanguageIndex = (allLanguages, path) => {
    const segmentsArray = path.split('/')
    let languageCode = segmentsArray[1]

    const thisLanguageIndex = allLanguages.findIndex(edge => {
        return edge.node.node_locale === languageCode
    })

    return thisLanguageIndex
}